import { api } from 'utils/hooks/useApi';
import { IDefaultConfig } from './_types';

export const getFrontendConfig = (): Promise<IDefaultConfig> =>
  api()
    .get(`/data/config.json?${new Date().getTime()}`)
    .then(({ data }) => data)
    .catch((error) => Promise.reject());
